import { IResponse } from '../contracts/IResponse';
import { HttpMethodEnum } from '../enums/enums';
import Inquiry from '../models/Inquiry';
import { BaseService } from './BaseService';

export class InquiryService extends BaseService {
    constructor() {
        super("inquiry");
    }

    async Create(model: Inquiry): Promise<IResponse<number>> {
        return fetch(`${this.EndPoint}/create`, { method: HttpMethodEnum.POST, body: JSON.stringify(model), headers: { "Content-Type": "application/json" } }).then(response => response.json())
    }
}
